import { TruckPlusIcon } from './TruckPlusIcon';

/**
 * author: Michael Richins
 * id CE4CCBED-7E6E-4F0C-ADF9-AC3347BF897D
 * name truck-plus
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/truck-plus.svg
 * tags
 * - Transportation + Road 
 * - Medical / Hospital 
 */
export const TruckAddIcon = TruckPlusIcon;
export default TruckAddIcon